export default "__VITE_ASSET__Cs3n0Oa7__"